export class Comment {
    sectionId: string;
    reportId: string;
    studentId: string;
    text: string = '';
}
